export const WORK_ORDERS_PAGE_VIEW = {
  LIST_VIEW: "LIST_VIEW",
  BOARD_VIEW: "BOARD_VIEW",
  MAP_VIEW: "MAP_VIEW",
  PLAN_CAPACITY_VIEW: "PLAN_CAPACITY_VIEW",
  TABLE_VIEW: "TABLE_VIEW",
};

export const WORK_ORDER_UPDATED_IDENTIFIER = "ticketUpdated";
export const WORK_ORDER_CREATED_IDENTIFIER = "ticketCreated";
export const WORK_ORDER_DELETED_IDENTIFIER = "ticketDeleted";

/**
 * A message was posted in a work order's external chat. Deliberately NOT
 * `ticketUpdated`: that identifier drives the list reorder below, so reusing it
 * would move the ticket to the top of every open list on each chat message
 * without `updatedAt` having changed. This one only refreshes unread counts.
 *
 * Published on the connection notification channel (see
 * `connectionNotificationChannels` in ChatCredentials), gated on `!isInternal`.
 */
export const WORK_ORDER_CHAT_MESSAGE_IDENTIFIER = "ticketChatMessage";

export const WORK_ORDER_BROADCAST_TOPICS = {
  REORDER_WORK_ORDER_LIST: "REORDER_WORK_ORDER_LIST",
  MEMBERSHIP_UPDATED: "MEMBERSHIP_UPDATED",
  // Recount the unread badge for specific channels. Serves both modules (the
  // response is identical either way: "re-read these channels"), same as
  // MEMBERSHIP_UPDATED.
  UNREAD_REFRESH: "UNREAD_REFRESH",
};

/**
 * Published by the pubnub-sync-membership Lambda whenever a user's channel
 * memberships change — ticket assignee/follower edits, but also team membership
 * and deletion, user deactivation and contact access revocation, none of which
 * pass through a ticket mutation. Carried with `isTicket` for work orders and
 * `isSupportTicket` for support tickets; a sync touching both modules publishes
 * one event per marker.
 */
export const MEMBERSHIP_UPDATED_IDENTIFIER = "membershipsUpdated";

export const WORK_ORDER_SORTING_KEY = {
  TITLE: "title",
  CREATED_AT: "created_at",
};
